import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  configureBaseUrlByRegion(countryCluster?: string): string {
    const host = window.location.host;
    let country = '';

    if (host.includes('.lt')) {
      country = 'lt';
    } else if (host.includes('.lv')) {
      country = 'lv';
    } else if (host.includes('.ee')) {
      country = 'ee';
    } else {
      country = 'lt';
    }

    const urlPrefix = environment['livasAPIBase' + country.toUpperCase()];
    const isUrlLangSlashNeeded = urlPrefix[urlPrefix.length - 1] !== '/';

    return `${urlPrefix}${isUrlLangSlashNeeded ? '/' : ''}${countryCluster ? countryCluster + '/' : ''}`;
  }
}
